/**
 * Browsers ignore `autocomplete="off"` on fields they recognise as credentials, so
 * password inputs get `new-password` (which suppresses saved-password autofill) and
 * everything else gets `off`.
 *
 * Pass an explicit `autoComplete` prop on any input that genuinely needs autofill.
 */
export const getAutoComplete = ({ type = 'text', isPassword = false } = {}) =>
  isPassword || type === 'password' ? 'new-password' : 'off';

export default getAutoComplete;
